import { GraphQLResult, GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import { API } from "aws-amplify";
import { useEffect, useState } from "react";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import {
  CheckAccountStateQuery,
  Game,
  GenerateGameSessionTokenTimelessTechMutation,
  GetGameByIdQuery,
} from "../../API";
import { RootState } from "../../app/store";
import {
  PlayerMode,
  selectPlayer,
  updateAccount,
} from "../../features/player/playerSlice";
import {
  Localization,
  selectTheme,
  showFooter,
  showLoading,
  ThemeMode,
} from "../../features/theme/themeSlice";
import { checkAccountState, getGameById } from "../../graphql/queries";
import AppLocale from "../../lang";
import { selectConfig } from "../../features/configapp";

import { generateGameSessionTokenTimelessTech } from "../../graphql/mutations";
type LocationState = {
  gameId: string;
};


const PlayTimelessTech = () => {
  const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
  const theme = useAppSelector(selectTheme);
  const player = useAppSelector(selectPlayer);
  const config = useAppSelector(selectConfig);
  const locale: Localization = theme.language as any;
  const languages: any = { it: "it-IT", en: "en-US" };
  const language = languages[locale];
  const currentAppLocale = AppLocale[locale];
  const dispatch = useDispatch();
  const location = useLocation();
  const locationState = location.state as LocationState;
  const [gameId, setGameId] = useState(locationState.gameId.split("#")[1]);
  const [gameProvider, setGameProvider] = useState(
    locationState.gameId.split("#")[0]
  );
  const [sessionToken, setSessionToken] = useState(null);
  const [buyInAmount, setBuyInAmount] = useState<number | null>(null);
  const [game, setGame] = useState<Game | null>(null);
  const navigate = useNavigate();

  const generateSession = (buyIn: number | null = null) => {
    (async () => {
      try {
        const result: GraphQLResult<GenerateGameSessionTokenTimelessTechMutation> =
          (await API.graphql({
            query: generateGameSessionTokenTimelessTech,
            authMode: player.logged
              ? GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS
              : GRAPHQL_AUTH_MODE.AWS_IAM,
            variables: {
              currency: player.account ? player.account.valute : "EUR",
              category: game.category,
              lang: language,
              gameId: `${gameProvider}#${gameId}`,
              buyIn: null,
            },
          })) as GraphQLResult<GenerateGameSessionTokenTimelessTechMutation>;

        if (result.data.generateGameSessionTokenTimelessTech.length > 20)
          setSessionToken(result.data.generateGameSessionTokenTimelessTech);
      } catch (e) {
        console.error(e);
      }
    })();
  };

  useEffect(() => {
    if (gameId) {
      (async () => {
        const result: GraphQLResult<GetGameByIdQuery> = (await API.graphql({
          query: getGameById,
          authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          variables: {
            gameId: `${gameProvider}#${gameId}`,
          },
        })) as GraphQLResult<GetGameByIdQuery>;

        if (result.data.getGameById) {
          console.log(result);
          setGame(result.data.getGameById);
        }
      })();
    }
  }, [gameId]);

  useEffect(() => {
    if (game) {
      setBuyInAmount(
        parseFloat(player.account.deposit.toFixed(2)) -
          parseFloat(player.account.expenses.toFixed(2)) +
          parseFloat(player.account.winnings.toFixed(2)) +
          parseFloat(player.account.bonus.toFixed(2)) -
          parseFloat(player.account.pickedUp.toFixed(2))
      );
    }
  }, [game]);

  useEffect(() => {
    if (buyInAmount) {
      generateSession(buyInAmount);
    }
  }, [buyInAmount]);

  useEffect(() => {
    console.log("virtual", player);
    dispatch(showFooter(false));
    if (!player.account) {
      (async () => {
        const result: GraphQLResult<CheckAccountStateQuery> =
          (await API.graphql({
            query: checkAccountState,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          })) as GraphQLResult<CheckAccountStateQuery>;

        dispatch(updateAccount(result.data.checkAccountState));
        generateSession();
      })();
      dispatch(showLoading(false));
    } else {
      dispatch(showLoading(false));
      generateSession();
    }
  }, []);

  return player.account && sessionToken && game ? (
    <iframe
      frameBorder={0}
      style={{
        width: "100%",
        height: `100vh`,
        position: "fixed",
        paddingBottom: `${player.mode === PlayerMode.KIOSK} ? '0' : ${
          theme.headerStatus ? "165px" : "68px"
        }`,
      }}
      src={`
			${game.gameLaunchUrl}/?mode=real&game_id=${gameId}&token=${sessionToken}&currency=${player.account.valute}&language=${language}&operator_id=${config.config.timelesstechOperatorId}&home_url=${config.config.home_url}`}
      title="TimelessTech"
    ></iframe>
  ) : (
    <div></div>
  );
};

export default PlayTimelessTech;
